
// src/web/components/settings-page.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/settings-page'
import {
  AppBar,
} from 'react-toolbox/lib/app_bar'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  NavDrawer,
  Layout,
  Panel,
} from 'react-toolbox/lib/layout'
import {
  List,
  ListItem,
  ListSubHeader,
} from 'react-toolbox/lib/list'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import settingsDialogTheme from './themes/settings-dialog.css'
import inactiveListItemTheme from './themes/inactive-list-item.css'
import activeListItemTheme from './themes/active-list-item.css'
import userAgent from './user-agent'

export class LinkPanel extends React.Component {
  render() {
    const {
      label,
      icon,
      url,
      onClose,
    } = this.props

    return (
      <a href={url} target='_blank' rel="noopener noreferrer" style={{ textDecoration: 'none' }} onClick={onClose} >
        <ListItem selectable
          caption={label}
          leftIcon={icon}
          theme={inactiveListItemTheme} />
      </a>
    )
  }
}

export class SettingsPanel extends React.Component {
  onClick = () => {
    this.props.selectPanel(this.props.name, undefined, this.props.params)
    this.props.onCloseDrawer()
  }

  render() {
    const {
      name,
      currentName,
      label,
      icon,
      params,
      children,
      component,
      subComponents,
      selectPanel,
    } = this.props

    return (
      <ListItem selectable
          caption={label}
          leftIcon={icon}
          theme={name == currentName && activeListItemTheme || inactiveListItemTheme}
          onMouseDown={this.onClick /* firefoxでなぜかonClickが動作しない不具合のため */}
          onTouchStart={this.onClick} />
    )
  }
}

class _SettingsPage extends React.Component {

  render() {
    const {
      t,
      ui,
      title,
      active,
      isPhone,
      children,
      updateUI,
      selectPanel,
      onCloseDrawer,
      onOpenDrawer,
      onCloseDialog,
    } = this.props

    const newProps = {
      currentName: ui.name,
      selectPanel, onCloseDrawer,
    }
    const _children = React.Children.map(children, (child)=> child && React.cloneElement(child, newProps))
    const childrenArray = React.Children.toArray(_children)
    var panel = childrenArray[0]
    if (ui.name)
      panel = _.find(childrenArray, (child)=> child.props.name == ui.name)

    var Component = panel.props.component
    var label = panel.props.label
    var params = panel.props.params
    var leftIcon = isPhone && 'menu' || ''
    var onLeftIconClick = ()=> onOpenDrawer(this.props)
    if (ui.subName && panel && panel.props.subPanel && panel.props.subPanel[ui.subName]) {
      Component = panel.props.subPanel[ui.subName].component
      label = label + ' / ' + panel.props.subPanel[ui.subName].label
      leftIcon = "arrow_back"
      onLeftIconClick = ()=> selectPanel(ui.name, undefined, undefined)
    }

    return (
      <Dialog active={active}
            type="large"
            onEscKeyDown={onCloseDialog}
            onOverlayClick={onCloseDialog}
            theme={settingsDialogTheme}>
        <Layout>
          <NavDrawer ref="navDrawer"
              active={ui.active}
              pinned={!isPhone}
              onOverlayClick={()=> onCloseDrawer(this.props)} 
              className='setting-nav-drawer' >
            <List>
              <ListItem caption={title} ripple={false} selectable={false}
                rightActions={
                  [<IconButton flat key="close" icon="close" onClick={onCloseDialog} />]
                } />
              {_children}
            </List>
          </NavDrawer>
          <Panel>
            <AppBar title={label} flat
                leftIcon={leftIcon}
                onLeftIconClick={onLeftIconClick}
                rightIcon="close"
                onRightIconClick={onCloseDialog}
                className='setting-nav-appbar'
              />
            <div 
              style={{
                marginTop: '56px',
                height: 'calc(100vh - 64px)',
                overflowY: 'auto',
              }}
            >
                <Component {...ui.params} {...params} selectPanel={selectPanel} onCloseDialog={onCloseDialog} />
            </div>
          </Panel>
        </Layout>
      </Dialog>
    )
  }
}

export const RawSettingsPage = _SettingsPage
export const SettingsPage = connect(_SettingsPage)



// WEBPACK FOOTER //
// ./src/web/components/settings-page.jsx